export const QueryKeys = {
  PROFILE: 'profile',
  ASSETS: 'assets',
};
